import { ChangeDetectorRef, Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { PRESETS_PERIODO_SEM_ONTEM_E_HOJE } from '../../shared/utils/periodo.utils';
import { ReceitaService } from '../../services/movimento/receita.service';
import { ContaService } from '../../services/conta/conta.service';
import { CotacaoGuardService } from '../../services/cotacao/cotacao-guard.service';
import { CotacaoService } from '../../services/cotacao/cotacao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, ConfirmationService, SortEvent } from 'primeng/api';
import { TipoDeReceita } from '../../enums/TipoReceita.enum';
import { Moeda } from '../../enums/moeda.enum';
import { TipoTransacao } from '../../enums/TipoTransacao.enum';
import { ReceitaDTO, ReceitaFiltrosDTO, TotalMoedaReceitaDTO, ReceitaDashboardDTO } from '../../models/gerenciar-contas/receita.model';
import { ContaDTO } from '../../models/gerenciar-contas/conta.model';
import { EmpresaConfigDTO, MoedaDTO } from '../../models/configuracoes/empresa.model';
import { TranslateService } from '@ngx-translate/core';
import { EmpresaConfigService } from '../../services/configuracoes/empresa.service';
import { debounceTime, distinctUntilChanged, firstValueFrom, Subject, Subscription } from 'rxjs';
import { PessoaService } from '../../services/pessoas/pessoas.service';
import { TipoReceitaService } from '../../services/enums/tipo-receita.service';
import { TableColumn } from '../../models/shared/table-column.model';
import { FormaPagamentoResult, DadosPagamentoDinheiro, DadosPagamentoConta } from '../../shared/components/forma-pagamento-dialog/forma-pagamento-dialog.interfaces';
import { PessoaDTO } from '../../models/clientes/pessoa.model';
import { EntitySelectorConfig } from '../../shared/components/entity-selector/entity-selector.interfaces';
import { PeriodoFiltro } from '../../models/dashboard/periodo-filtro.model';
import { Calendar } from 'primeng/calendar';
import { PermissaoService } from '../../services/permissao/permissao.service';
import { NotaService } from '../../services/financeiro/notas.service';
import { moedasCompativeis } from '../../utils/moeda-pareamento.util';
import { toLocalISOString } from '../../shared/utils/date-utils';

@Component({
  selector: 'app-nova-receita',
  templateUrl: './nova-receita.component.html',
  styleUrls: ['./nova-receita.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class NovaReceitaComponent implements OnInit, OnDestroy {
  @ViewChild('calendario') calendario!: Calendar;

  // Opcoes do filtro de periodo (sem "Ontem e hoje")
  readonly opcoesPeriodo = PRESETS_PERIODO_SEM_ONTEM_E_HOJE;

  // Controle de abas (0 = Cadastro, 1 = Lista)
  activeTabIndex: number = 1;

  // Label dinamico do botao "Outros" (mostra data selecionada)
  outrosLabel = '';

  // Controle de validacao visual
  isFormSubmitted = false;
  // String formatada do campo valor (para evitar que ngModel sobrescreva a mascara)
  montanteStr = '';

  // Objetos de traducao (seguindo padrao nova-despesa)
  texts = {
    titulo: '',
    subtitulo: '',
    aba_cadastro: '',
    aba_lista: '',
    dados_da_receita: '',
    valor_e_data: '',
    lista_de_receitas: '',
    nenhuma_receita: '',
    ajuste_filtros: '',
    carregando: '',
    confirmacao: '',
    confirmar_exclusao: '',
    filtros_titulo: '',
    filtros_avancados: '',
    filtros_avancados_subtitulo: '',
    total_guarani: '',
    total_dolar: '',
    total_real: '',
    total_peso: '',
    nova_receita: '',
  };

  labels = {
    descricao: '',
    tipo_de_receita: '',
    pessoa_cliente: '',
    pessoa: '',
    moeda: '',
    valor: '',
    data: '',
    hoje: '',
    ontem: '',
    outros: '',
    id: '',
    data_emissao: '',
    observacao: '',
    tipo_receita: '',
    acoes: '',
    ruc: '',
    nome_cliente: '',
    ddi: '',
    telefone: '',
    cidade: '',
    itens_por_pagina: '',
    filtro_observacao: '',
    filtro_cliente: '',
    filtro_tipo_receita: '',
    filtro_periodo: '',
    filtro_conta: '',
  };

  placeholders = {
    descricao: '',
    selecionar: '',
    buscar: '',
    valor: '',
    ruc: '',
    nome_cliente: '',
    telefone: '',
    filtro_observacao: '',
  };

  botoes = {
    salvar: '',
    atualizar: '',
    limpar: '',
    cancelar: '',
    adicionar: '',
    confirmar: '',
    filtrar: '',
    limpar_filtros: '',
  };

  tooltips = {
    editar: '',
    excluir: '',
    abrir_calendario: '',
    imprimir: '',
    ver_fatura: '',
    ver_transferencia: '',
  };

  private langChangeSub!: Subscription;

  // Sidebar de filtros avancados
  sidebarFiltrosVisible = false;

  // Wave dialog de exclusao
  deleteDialogVisible = false;
  deleteItemId: number | null = null;

  form: ReceitaDTO = this.createEmptyForm();
  receitas: ReceitaDTO[] = [];
  receitasOriginal: ReceitaDTO[] = [];
  tiposReceita: { label: string; value: string; icone?: string; cor?: string }[] = [];
  moedas = this.getEnumOptions(Moeda);
  contas: { label: string; value: number; flagUrl: string }[] = [];
  /** Contas completas do backend (usado para detectar conta bancaria) */
  private contasFull: any[] = [];
  /** Flag para evitar reload duplicado na auto-selecao de conta */
  private _initialLoadDone = false;
  /** Flags de prontidao do bootstrap (coordenam o PRIMEIRO loadReceitas/carregarTotais
   *  para que ele dispare UMA so vez, depois que empresa, contas e tipos de receita
   *  estejam carregados. Isto evita chamadas duplicadas a listarReceitasPorFiltros
   *  e total-receitas na carga inicial (a auto-selecao de conta DINHEIRO depende de
   *  empresa E contas; sem empresa o filtro de conta nao e aplicado no primeiro load). */
  private _empresaReady = false;
  private _contasReady = false;
  private _tiposReceitaReady = false;
  moeda: { label: string; value: Moeda; flagUrl: string }[] = [];
  empresa: EmpresaConfigDTO | null = null;
  dataSelecionada: string = 'hoje';
  clientesList: { label: string; value: any }[] = [];
  clientes: any[] = [];
  clienteSelecionado: any = null;
  pessoaSelecionada: PessoaDTO | undefined;
  clienteSelectorConfig!: EntitySelectorConfig;
  visibleDialogCliente: boolean = false;
  searchTerm: string = '';
  rows: number = 10;
  loading: boolean = true;
  totalRecords: number = 0;
  first: number = 0;

  // Estado de ordenacao server-side (padrao MovimentacaoComponent)
  lastfield: string = 'emissao';
  lastSort: string = 'asc';
  pageSizeOptions = [
    { label: 5, value: 5 },
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 120, value: 120 },
  ];
  // Configuracao de colunas visiveis (padrao pessoas-table)
  readonly STORAGE_KEY = 'nova-receita-visible-columns';

  columns: TableColumn[] = [
    { key: 'id', labelKey: 'nova-receita.labels.id', visible: true, fixed: true, defaultVisible: true },
    { key: 'emissao', labelKey: 'nova-receita.labels.data_emissao', visible: true, fixed: false, defaultVisible: true },
    { key: 'observacao', labelKey: 'nova-receita.labels.observacao', visible: true, fixed: false, defaultVisible: true },
    { key: 'tipoReceita', labelKey: 'nova-receita.labels.tipo_receita', visible: true, fixed: false, defaultVisible: true },
    { key: 'pessoa', labelKey: 'nova-receita.labels.pessoa', visible: true, fixed: false, defaultVisible: true },
    { key: 'valor', labelKey: 'nova-receita.labels.valor', visible: true, fixed: false, defaultVisible: true },
    { key: 'acoes', labelKey: 'nova-receita.labels.acoes', visible: true, fixed: true, defaultVisible: true },
  ];

  movimento?: any;
  private search$: Subject<string> = new Subject<string>();

  // Componente de forma de pagamento
  mostrarDialogPagamento = false;
  moedaPadraoISO: 'BRL' | 'PYG' | 'USD' | 'ARS' = 'BRL';
  /**
   * Moeda padrao da EMPRESA em codigo ISO. Propagada ao dialog para que o
   * filtro de cards seja a INTERSECAO entre MOEDAS_COMPATIVEIS da moeda do
   * registro (moedaPadraoISO) e MOEDAS_COMPATIVEIS da moeda da empresa.
   * Ex.: registro em Guarani + empresa em Real -> oculta o card PESO.
   * Atualizada em findEmpresa() e em abrirDialogPagamento() (defesa em profundidade).
   */
  moedaEmpresaISO: 'BRL' | 'PYG' | 'USD' | 'ARS' | undefined;
  contasFormatadas: { label: string; value: any }[] = [];
  processandoReceita = false;
  submitting = false;

  // Cotacoes (USD como base)
  cotUSD = 1;
  cotPYG = 7180;
  cotBRL = 5.47;
  /** Cotacao Peso Argentino em Guaranis (1 ARS = N PYG). 0 = peso desabilitado. */
  cotPesoGuarani = 0;
  /** Cotacao direta BRL->PYG (1 BRL = N PYG). 0 = triangulacao via USD. */
  cotRealGuarani = 0;

  // === Filtros server-side (ajuste-tela-novo-ingresso) ===
  filtroObservacao: string = '';
  filtroPessoaId: number | null = null;
  filtroPessoaSelecionada: PessoaDTO | undefined;
  filtroPessoaSelectorConfig!: EntitySelectorConfig;
  filtroTipoReceita: string | null = null;
  filtroDataInicio: Date | null = null;
  filtroDataFim: Date | null = null;
  filtroConta: number | null = null;
  periodoReceitaTexto: string = '';
  filtrosAtivos: boolean = false;
  filtroMoedaSelecionada: string | null = null;

  // Tipos de receita para dropdown de filtro
  tiposReceitaFiltro: { label: string; value: string; icone?: string; cor?: string }[] = [];

  // Mapa de tipos de receita com icone e cor (carregado do backend)
  tipoReceitaMap: Map<string, { icone: string; cor: string }> = new Map();

  // Totais por moeda
  totais: TotalMoedaReceitaDTO = {
    valorTotalEmGuarani: 0,
    valorTotalEmDolar: 0,
    valorTotalEmReal: 0,
  };
  loadingTotais: boolean = false;

  /** Retorna true quando a conta selecionada no filtro é uma conta bancária (tipoConta === 'BANCO'). */
  get contaBancariaAtiva(): boolean {
    if (this.filtroConta == null) return false;
    const conta = this.contasFull.find(c => c.id === this.filtroConta);
    const tipo = conta?.tipoConta;
    const tipoStr = typeof tipo === 'object' ? (tipo as any)?.enum : tipo;
    return tipoStr === 'BANCO';
  }

  /** Retorna o enum da moeda da conta selecionada (GUARANI, DOLAR, REAL) ou null. */
  get moedaContaSelecionada(): string | null {
    if (this.filtroConta == null) return null;
    const conta = this.contasFull.find(c => c.id === this.filtroConta);
    return conta?.moeda?.enum || null;
  }

  /**
   * Conjunto de moedas permitidas para a empresa logada, baseado na
   * matriz de pareamento (moedasCompativeis). Usado para filtrar quais
   * cards de Total exibir.
   *
   * Fallback: enquanto a empresa nao carregou, retorna o conjunto completo
   * (todas as 4 moedas) para evitar placeholder vazio. O filtro fica
   * estavel apos a primeira resposta de getSessao().
   */
  get moedasPermitidas(): Set<string> {
    const moedaEmp = this.empresa?.moeda
      ? this.asEnumString(this.empresa.moeda)
      : null;
    if (!moedaEmp) return new Set(['GUARANI', 'DOLAR', 'REAL', 'PESO']);
    return new Set(moedasCompativeis(moedaEmp as any));
  }

  // Impressao PDF
  imprimindoId: number | null = null;
  mostrarDialogoImpressao = false;
  opcaoImpressao = 'A4';
  private idParaImprimir: number | null = null;
  private tipoParaImprimir: string = 'MOVIMENTO';

  constructor(
    private receitaService: ReceitaService,
    private contaService: ContaService,
    private cotacaoService: CotacaoService,
    private cotacaoGuard: CotacaoGuardService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute,
    private empresaService: EmpresaConfigService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private pessoaService: PessoaService,
    private tipoReceitaService: TipoReceitaService,
    private permissaoService: PermissaoService,
    private notaService: NotaService,
  ) { }

  ngOnInit() {
    // showAddInDropdown somente se o usuario tiver permissao de cadastrar clientes
    const podeAdicionarCliente = this.permissaoService.temPermissao('cliente');

    this.clienteSelectorConfig = {
      categoryFilter: 'categoriaCliente=true',
      placeholder: this.translate.instant('nova-receita.placeholders.selecionar') || this.placeholders.selecionar,
      showAddButton: false,
      showAddInDropdown: podeAdicionarCliente,
      dialogTitle: this.translate.instant('nova-receita.texts.selecionar_pessoa') || this.texts.titulo,
      dialogIcon: 'pi pi-users',
    };

    this.filtroPessoaSelectorConfig = {
      categoryFilter: 'categoriaCliente=true',
      placeholder: this.translate.instant('nova-receita.placeholders.selecionar') || this.placeholders.selecionar,
      showAddButton: false,
      showAddInDropdown: podeAdicionarCliente,
      dialogTitle: this.translate.instant('nova-receita.texts.selecionar_pessoa') || this.texts.titulo,
      dialogIcon: 'pi pi-users',
    };

    this.loadColumnPreferences();
    this.loadContas();
    this.lerFiltrosDashboard();
    this.buildMoedaOptions();
    // Pre-selecao defensiva da primeira moeda enquanto findEmpresa() nao
    // resolve. O `findEmpresa.next` (linhas ~629-635) sobrepoe esta selecao
    // pela moeda padrao da empresa quando ela chegar. Se a empresa estiver
    // disponivel sincronamente (cache), a etapa de fallback nao se aplica.
    if (!this.form.moeda && this.moeda.length > 0) {
      this.form.moeda = this.moeda[0];
    }
    this.carregarClientes();
    this.findEmpresa();
    this.setupSearchDebounce();
    this.definirDataHoje();
    // Carregar traducoes primeiro para que tiposReceita esteja populado
    // antes de o mapa de icones ser aplicado
    // Abrir aba de cadastro se vier do menu de atalhos com aba=cadastro
    if (this.route.snapshot.queryParams['aba'] === 'cadastro') {
      this.activeTabIndex = 0;
    }

    this.loadTranslations();
    this.loadTiposReceitaMap(() => {
      // Apos o mapa ser populado, re-enriquecer o dropdown com icones/cores
      this.enriquecerDropdownTiposReceita();
      this._tiposReceitaReady = true;
      this.dispararCargaInicialSePronto();
    });

    // Atualiza traducoes quando idioma muda
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
      this.buildMoedaOptions();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
    this.search$.complete();
  }

  /** Lê filtros passados pelo dashboard via queryParams e os aplica automaticamente */
  private lerFiltrosDashboard(): void {
    const params = this.route.snapshot.queryParams;
    const dataInicial = params['dataInicial'];
    const dataFinal = params['dataFinal'];
    const contaId = params['contaId'];

    if (dataInicial) {
      this.filtroDataInicio = this.parsarDataDashboard(dataInicial);
    }
    if (dataFinal) {
      this.filtroDataFim = this.parsarDataDashboard(dataFinal);
    }
    if (contaId) {
      const id = parseInt(contaId, 10);
      if (!isNaN(id)) {
        this.filtroConta = id;
      }
    }

    if (this.filtroDataInicio || this.filtroDataFim || this.filtroConta !== null) {
      this.filtrosAtivos = true;
      // Veio do dashboard com filtros: abrir diretamente na aba de lista
      this.activeTabIndex = 1;
    } else {
      // Sem parâmetros do dashboard: aplicar período padrão "Mostrar todos"
      // (showAll), equivalente ao valorPadrao='showAll' do app-periodo-filtro.
      // Intervalo fixo 01/01/2000 00:00 -> 31/12/3000 23:59 (alinhado ao mobile).
      this.filtroDataInicio = new Date(2000, 0, 1, 0, 0, 0);
      this.filtroDataFim = new Date(3000, 11, 31, 23, 59, 59);
      this.filtrosAtivos = true;
    }
  }

  /**
   * Converte string no formato dd/MM/yyyyTHH:mm (enviado pelo dashboard)
   * para objeto Date que os filtros da tela esperam.
   */
  private parsarDataDashboard(valor: string): Date | null {
    try {
      // Formato esperado: dd/MM/yyyyTHH:mm
      const [datePart, timePart] = valor.split('T');
      if (!datePart) return null;
      const [dia, mes, ano] = datePart.split('/').map(Number);
      const [hora, minuto] = (timePart || '00:00').split(':').map(Number);
      const d = new Date(ano, mes - 1, dia, hora || 0, minuto || 0);
      return isNaN(d.getTime()) ? null : d;
    } catch {
      return null;
    }
  }

  private loadTranslations(): void {
    const isEdicao = !!this.form.id;
    const isListaAtiva = this.activeTabIndex === 1;

    this.texts = {
      titulo: this.translate.instant(
        isListaAtiva ? 'nova-receita.texts.titulo_nova' : isEdicao ? 'nova-receita.texts.titulo_editar' : 'nova-receita.texts.titulo_nova'
      ),
      subtitulo: this.translate.instant(
        isListaAtiva
          ? 'nova-receita.texts.subtitulo_lista'
          : isEdicao
          ? 'nova-receita.texts.subtitulo_editar'
          : 'nova-receita.texts.subtitulo_nova'
      ),
      aba_cadastro: this.translate.instant('nova-receita.texts.aba_cadastro'),
      aba_lista: this.translate.instant('nova-receita.texts.aba_lista'),
      dados_da_receita: this.translate.instant('nova-receita.texts.dados_da_receita'),
      valor_e_data: this.translate.instant('nova-receita.texts.valor_e_data'),
      lista_de_receitas: this.translate.instant('nova-receita.texts.lista_de_receitas'),
      nenhuma_receita: this.translate.instant('nova-receita.texts.nenhuma_receita'),
      ajuste_filtros: this.translate.instant('nova-receita.texts.ajuste_filtros'),
      carregando: this.translate.instant('nova-receita.texts.carregando'),
      confirmacao: this.translate.instant('common.confirmacao'),
      confirmar_exclusao: this.translate.instant('nova-receita.mensagens.confirmar_exclusao'),
      filtros_titulo: this.translate.instant('nova-receita.filtros.titulo'),
      filtros_avancados: this.translate.instant('nova-receita.filtros.avancados'),
      filtros_avancados_subtitulo: this.translate.instant('nova-receita.filtros.avancados_subtitulo'),
      total_guarani: this.translate.instant('nova-receita.totais.guarani'),
      total_dolar: this.translate.instant('nova-receita.totais.dolar'),
      total_real: this.translate.instant('nova-receita.totais.real'),
      total_peso: this.translate.instant('nova-receita.totais.peso'),
      nova_receita: this.translate.instant('nova-receita.texts.nova_receita'),
    };

    this.labels = {
      descricao: this.translate.instant('nova-receita.labels.descricao'),
      tipo_de_receita: this.translate.instant('nova-receita.labels.tipo_de_receita'),
      pessoa_cliente: this.translate.instant('nova-receita.labels.pessoa_cliente'),
      pessoa: this.translate.instant('nova-receita.labels.pessoa'),
      moeda: this.translate.instant('nova-receita.labels.moeda'),
      valor: this.translate.instant('nova-receita.labels.valor'),
      data: this.translate.instant('nova-receita.labels.data'),
      hoje: this.translate.instant('nova-receita.labels.hoje'),
      ontem: this.translate.instant('nova-receita.labels.ontem'),
      outros: this.translate.instant('nova-receita.labels.outros'),
      id: this.translate.instant('nova-receita.labels.id'),
      data_emissao: this.translate.instant('nova-receita.labels.data_emissao'),
      observacao: this.translate.instant('nova-receita.labels.observacao'),
      tipo_receita: this.translate.instant('nova-receita.labels.tipo_receita'),
      acoes: this.translate.instant('nova-receita.labels.acoes'),
      ruc: this.translate.instant('nova-receita.labels.ruc'),
      nome_cliente: this.translate.instant('nova-receita.labels.nome_cliente'),
      ddi: this.translate.instant('nova-receita.labels.ddi'),
      telefone: this.translate.instant('nova-receita.labels.telefone'),
      cidade: this.translate.instant('nova-receita.labels.cidade'),
      itens_por_pagina: this.translate.instant('nova-receita.labels.itens_por_pagina'),
      filtro_observacao: this.translate.instant('nova-receita.filtros.observacao'),
      filtro_cliente: this.translate.instant('nova-receita.filtros.cliente'),
      filtro_tipo_receita: this.translate.instant('nova-receita.filtros.tipo_receita'),
      filtro_periodo: this.translate.instant('nova-receita.filtros.periodo'),
      filtro_conta: this.translate.instant('nova-receita.filtros.conta'),
    };

    this.placeholders = {
      descricao: this.translate.instant('nova-receita.placeholders.descricao'),
      selecionar: this.translate.instant('nova-receita.placeholders.selecionar'),
      buscar: this.translate.instant('nova-receita.placeholders.buscar'),
      valor: this.translate.instant('nova-receita.placeholders.valor'),
      ruc: this.translate.instant('nova-receita.placeholders.ruc'),
      nome_cliente: this.translate.instant('nova-receita.placeholders.nome_cliente'),
      telefone: this.translate.instant('nova-receita.placeholders.telefone'),
      filtro_observacao: this.translate.instant('nova-receita.filtros.placeholder_observacao'),
    };

    this.botoes = {
      salvar: this.translate.instant('nova-receita.botoes.salvar'),
      atualizar: this.translate.instant('nova-receita.botoes.atualizar'),
      limpar: this.translate.instant('nova-receita.botoes.limpar'),
      cancelar: this.translate.instant('nova-receita.botoes.cancelar'),
      adicionar: this.translate.instant('nova-receita.botoes.adicionar'),
      confirmar: this.translate.instant('nova-receita.botoes.confirmar'),
      filtrar: this.translate.instant('nova-receita.filtros.aplicar'),
      limpar_filtros: this.translate.instant('nova-receita.filtros.limpar'),
    };

    this.tooltips = {
      editar: this.translate.instant('nova-receita.tooltips.editar'),
      excluir: this.translate.instant('nova-receita.tooltips.excluir'),
      abrir_calendario: this.translate.instant('nova-receita.tooltips.abrir_calendario'),
      imprimir: this.translate.instant('nova-receita.tooltips.imprimir'),
      ver_fatura: this.translate.instant('nova-receita.tooltips.ver_fatura'),
      ver_transferencia: this.translate.instant('nova-receita.tooltips.ver_transferencia'),
    };

    // Atualizar label do botao "Outros" conforme estado atual
    if (this.dataSelecionada === 'outros' && this.form.emissao) {
      this.outrosLabel = this.formatarDataParaExibicao(this.form.emissao);
    } else {
      this.outrosLabel = this.labels.outros;
    }

    // Carregar tipos de receita com traducao
    const valorAtual = this.form.tipoReceita;
    this.tiposReceita = Object.values(TipoDeReceita).map((value) => ({
      label: this.translate.instant(`nova-receita.tipos_receita.${value}`),
      value: value as string,
      icone: this.tipoReceitaMap.get(value)?.icone || '',
      cor: this.tipoReceitaMap.get(value)?.cor || '',
    }));
    // Preservar selecao atual apos recarregar labels
    if (valorAtual) {
      this.form.tipoReceita = valorAtual;
    }

    // Atualiza dropdown de filtro de tipos de receita
    this.tiposReceitaFiltro = [...this.tiposReceita];
  }

  isColumnVisible(key: string): boolean {
    const col = this.columns.find(c => c.key === key);
    return col ? col.visible : true;
  }

  get visibleColumnCount(): number {
    return this.columns.filter(c => c.visible).length;
  }

  onColumnsChange(columns: TableColumn[]): void {
    this.columns = [...columns];
  }

  private loadColumnPreferences(): void {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        const visibleKeys = JSON.parse(stored) as string[];
        this.columns.forEach(col => {
          if (!col.fixed) {
            col.visible = visibleKeys.includes(col.key);
          }
        });
      }
    } catch (e) {
      console.warn('Erro ao carregar preferências de colunas:', e);
    }
  }

  getDropItems(enumType: any): { label: string; value: any }[] {
    return Object.values(enumType).map((item) => ({
      label: String(item).toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      value: item,
    }));
  }

  private buildMoedaOptions(): void {
    const permitidas = this.moedasPermitidas;
    // Edge case: ao editar receita em moeda agora bloqueada (legacy),
    // manter a moeda atual visivel para nao "sumir" o valor selecionado.
    // No fluxo de cadastro novo, form.moeda eh undefined, entao
    // moedaAtual = null e o filtro fica estritamente nas permitidas.
    const moedaAtual = this.form?.moeda
      ? this.asEnumString((this.form.moeda as any).value ?? this.form.moeda)
      : null;

    this.moeda = Object.values(Moeda)
      .filter(m => {
        const codigo = this.asEnumString(m);
        return permitidas.has(codigo) || codigo === moedaAtual;
      })
      .map(moeda => ({
        label: this.translate.instant(`enums.moeda.${moeda.toLowerCase()}`),
        value: moeda,
        flagUrl: this.getFlagUrl(moeda),
      }));
  }

  getFlagUrl(moeda: any): string {
    const moedaStr = this.asEnumString(moeda);
    switch (moedaStr) {
      case 'GUARANI': return 'assets/images/paraguay-flag.jpg';
      case 'REAL': return 'assets/images/br-flag.svg';
      case 'DOLAR': return 'assets/images/usa-flag.svg';
      case 'PESO': return 'assets/images/argentina-flag.svg';
      default: return '';
    }
  }

  loadCotacao() {
    const moeda = this.form.moedaDeOrigem;
    if (moeda) {
      this.cotacaoService.getCotacaoAtual(moeda).subscribe((response) => {
        this.form.cotacao_id = response.id!;
      });
    }
  }

  carregarClientes(): void {
    this.pessoaService.get('/pessoas/buscar').subscribe((res) => {
      this.clientes = res.content.map((c: any) => ({ id: c.id, nome: c.nome, fantasia: c.fantasia, email: c.email, ruc: c.ruc }));
    });
  }

  findEmpresa() {
    this.empresaService.getById('/configuracaoEmpresa/sessao').subscribe({
      next: (response) => {
        this.empresa = response;
        // Re-monta dropdown de moeda agora que `moedasPermitidas` reflete a
        // moeda padrao da empresa (sem fallback para todas as 4).
        this.buildMoedaOptions();
        // Setar moeda padrao ISO para o componente de forma de pagamento
        const moeda = this.empresa?.moeda as MoedaDTO | undefined;
        if (moeda) {
          const codigoOperacao =
            (moeda as any)?.codigoOperacao ??
            ((moeda as any)?.enum === 'REAL' ? 'BRL' : (moeda as any)?.enum === 'DOLAR' ? 'USD' : (moeda as any)?.enum === 'PESO' ? 'ARS' : 'PYG');
          this.moedaPadraoISO = (codigoOperacao as 'BRL' | 'PYG' | 'USD' | 'ARS');
          // Guardar tambem a moeda da empresa em ISO (usada como segundo
          // filtro nos cards do dialog de pagamento — vide abrirDialogPagamento).
          this.moedaEmpresaISO = this.moedaPadraoISO;
        }
        // Sincronizar dropdown de moeda com a moeda padrao da empresa
        // Apenas quando nao ha receita em edicao, para nao sobrescrever a moeda do registro carregado
        if (this.empresa?.moeda && !this.form.id) {
          const moedaEmpresaEnum = this.asEnumString(this.empresa.moeda);
          const moedaOpcao = this.moeda.find(m => this.asEnumString(m.value) === moedaEmpresaEnum);
          if (moedaOpcao) {
            this.form.moeda = moedaOpcao;
          }
        }
        // Carregar cotacoes para multi-moeda
        this.carregarCotacoes();

        // A auto-selecao de conta DINHEIRO e executada em dispararCargaInicialSePronto(),
        // depois que empresa, loadContas e loadTiposReceitaMap estiverem prontos.
        // Evita chamadas duplicadas a listarReceitasPorFiltros.
        this._empresaReady = true;
        this.dispararCargaInicialSePronto();
      },
      error: (error) => {
        console.error("Erro ao buscar empresa:", error);
        // Mesmo em erro, liberar a carga inicial para nao travar a pagina.
        this._empresaReady = true;
        this.dispararCargaInicialSePronto();
      }
    });
  }

  carregarCotacoes(): void {
    this.cotacaoService.get('/cotacao/ultimaCotacao').subscribe({
      next: (res: any) => {
        if (res) {
          this.cotPYG = res.dolarGuarani || 7180;
          this.cotBRL = res.dolarReal || 5.47;
          // pesoGuarani e opcional; sem valor, coluna peso permanece oculta
          this.cotPesoGuarani = res.pesoGuarani || 0;
          // realGuarani: cotacao direta BRL->PYG; 0 = fallback triangulacao
          this.cotRealGuarani = res.realGuarani || 0;
        }
      },
      error: () => {
        // Mantem valores padrao
      }
    });
  }

  /**
   * Auto-seleciona a conta tipo DINHEIRO da moeda padrao da empresa,
   * igualando o comportamento do mobile.
   * So executa quando:
   *  - Contas ja foram carregadas (contasFull populado)
   *  - Empresa ja foi carregada (empresa com moeda)
   *  - filtroConta ainda nao foi definido (nao veio do dashboard)
   */
  private autoSelecionarContaDinheiro(): void {
    // Nao executar se filtroConta ja foi definido (ex: veio do dashboard via queryParam)
    if (this.filtroConta != null) return;

    // Aguardar que ambos os dados estejam disponiveis
    if (!this.contasFull || this.contasFull.length === 0) return;
    if (!this.empresa?.moeda) return;

    const moedaPadraoEnum = this.asEnumString(this.empresa.moeda);

    const contaDinheiro = this.contasFull.find(c => {
      const tipo = this.asEnumString(c.tipoConta);
      const moedaConta = this.asEnumString(c.moeda);
      return tipo === 'DINHEIRO' && moedaConta === moedaPadraoEnum;
    });

    if (contaDinheiro?.id) {
      this.filtroConta = contaDinheiro.id;
      this.filtroMoedaSelecionada = moedaPadraoEnum;
      this.filtrosAtivos = true;

      // Se o carregamento inicial ja aconteceu, recarregar com o filtro correto.
      // No fluxo atual coordenado (dispararCargaInicialSePronto), o filtro e setado
      // ANTES do primeiro load, entao este bloco so age se a empresa chegar depois
      // (caso raro). Mantido por seguranca.
      if (this._initialLoadDone) {
        this.loadReceitas(0, this.rows);
        this.carregarTotais();
      }
    }
  }

  /**
   * Coordena o PRIMEIRO loadReceitas + carregarTotais:
   * so dispara quando contas e tipos de receita ja estao prontos.
   * Antes de disparar, aplica autoSelecionarContaDinheiro para que o
   * primeiro load ja saia com o filtro de conta correto (evitando reload duplicado).
   * Tambem processa queryParams editId/pessoaId que dependiam do bootstrap.
   */
  private dispararCargaInicialSePronto(): void {
    if (!this._empresaReady || !this._contasReady || !this._tiposReceitaReady) return;
    if (this._initialLoadDone) return;

    // Tentar auto-selecionar a conta DINHEIRO antes do primeiro load,
    // para que ele ja saia com o filtro correto (conta=<id>).
    // findEmpresa tambem alimenta this.empresa; se ainda nao chegou, o
    // early return do auto-select preserva o comportamento anterior.
    this.autoSelecionarContaDinheiro();

    this._initialLoadDone = true;
    this.loadReceitas(0, this.rows);
    // Carregar totais sempre (cards de moeda sempre visiveis)
    this.carregarTotais();

    // Se veio editId via queryParams (navegacao da lista de movimentos), carregar receita para edicao
    const editId = this.route.snapshot.queryParams['editId'];
    if (editId) {
      this.carregarReceitaParaEdicao(+editId);
    }

    // Pre-selecionar pessoa via queryParam (navegacao de acoes rapidas de clientes)
    const pessoaIdParam = this.route.snapshot.queryParams['pessoaId'];
    if (pessoaIdParam && !editId) {
      this.pessoaService.get(`/pessoas/${pessoaIdParam}`).subscribe(
        (pessoa: any) => {
          const pessoaDTO = pessoa as PessoaDTO;
          // Preenche formulario de cadastro
          this.pessoaSelecionada = pessoaDTO;
          this.form.pessoa_id = pessoaDTO.id;
          // Preenche filtro da aba Lista e aplica
          this.filtroPessoaSelecionada = pessoaDTO;
          this.filtroPessoaId = pessoaDTO.id ?? null;
          this.aplicarFiltros();
        }
      );
    }
  }

  /** Carrega tipos de receita do backend para obter icone e cor.
   *  O callback onComplete e chamado ao finalizar (com ou sem erro),
   *  garantindo que loadReceitas so execute apos o mapa estar populado.
   */
  loadTiposReceitaMap(onComplete?: () => void): void {
    this.tipoReceitaService.get<any>('/enums/tipoReceita', {
      size: 50,
      sort: 'nome,asc',
    }).subscribe({
      next: (response: any) => {
        const tipos = Array.isArray(response) ? response : response?.content || [];
        tipos.forEach((tipo: any) => {
          // Indexar pelo campo "enum" (nome da constante, ex: "SALARIO_DE_CLIENTE")
          // que e o valor retornado pelo endpoint de filtros (ReceitaDashboardDTO)
          const chave = tipo.enum || tipo.nome;
          if (chave) {
            this.tipoReceitaMap.set(chave, {
              icone: tipo.icone || '',
              cor: tipo.cor || '',
            });
          }
        });
        this.enriquecerDropdownTiposReceita();
        // BUG FIX: adicionar tipos suportados pelo backend que nao existem no
        // enum local TipoDeReceita (ex: BONIFICACOES_RECEBIDAS). Sem isto, ao
        // editar uma receita com um desses tipos, o dropdown fica vazio porque
        // o .find() em editarReceita nao encontra correspondencia.
        const valoresExistentes = new Set(
          this.tiposReceita.map(t => String(t.value).toUpperCase())
        );
        tipos.forEach((tipo: any) => {
          const chave = String(tipo.enum || '').toUpperCase();
          if (chave && !valoresExistentes.has(chave) && tipo.exibir !== false) {
            this.tiposReceita.push({
              label: tipo.nome || chave,
              value: chave,
              icone: tipo.icone || '',
              cor: tipo.cor || '',
            });
            valoresExistentes.add(chave);
          }
        });
        this.tiposReceitaFiltro = [...this.tiposReceita];
        onComplete?.();
      },
      error: () => {
        // Silencioso - tabela funciona sem icones
        onComplete?.();
      },
    });
  }

  /** Enriquece o dropdown de tipos de receita com icone e cor do mapa */
  enriquecerDropdownTiposReceita(): void {
    if (this.tipoReceitaMap.size === 0) return;
    this.tiposReceita = this.tiposReceita.map(tipo => ({
      ...tipo,
      icone: this.tipoReceitaMap.get(tipo.value)?.icone || '',
      cor: this.tipoReceitaMap.get(tipo.value)?.cor || '',
    }));
    this.tiposReceitaFiltro = [...this.tiposReceita];
  }


  get clientesComAdicionar(): any[] {
    const clientesNormais = this.clientes.map(cliente => ({
      ...cliente,
      id: cliente.id
    }));

    const resultado = [
      ...clientesNormais,
      {
        id: -1,
        nome: 'adicionar',
        isAddButton: true
      }
    ];
    return resultado;
  }

  loadContas() {
    this.contaService.get('/conta').subscribe((response) => {
      this.contasFull = response.content;
      // Filtra contas visiveis no dropdown pelas moedas permitidas conforme
      // moeda padrao da empresa (regra de pareamento). Mantem `contasFull`
      // completo para preservar lookups por id (moedaContaSelecionada,
      // autoSelecionarContaDinheiro) e `contasFormatadas` para o formulario de
      // cadastro.
      const permitidas = this.moedasPermitidas;
      const contasVisiveis = response.content.filter((conta: ContaDTO) =>
        permitidas.has(this.asEnumString((conta as any).moeda)),
      );
      this.contas = contasVisiveis.map((conta: ContaDTO) => ({
        label: (conta as any).numeroConta == 0 ? `${conta.tituloDaConta} - EFETIVO` : conta.tituloDaConta,
        value: conta.id!,
        flagUrl: this.getFlagUrl(conta.moeda),
      }));

      // Ordenar: conta DINHEIRO da moeda padrao da empresa aparece primeiro
      if (this.empresa?.moeda) {
        const moedaPadrao = this.asEnumString(this.empresa.moeda);
        this.contas.sort((a, b) => {
          const contaA = this.contasFull.find(c => c.id === a.value);
          const contaB = this.contasFull.find(c => c.id === b.value);
          const isTopA = contaA && this.asEnumString(contaA.tipoConta) === 'DINHEIRO' && this.asEnumString(contaA.moeda) === moedaPadrao ? 1 : 0;
          const isTopB = contaB && this.asEnumString(contaB.tipoConta) === 'DINHEIRO' && this.asEnumString(contaB.moeda) === moedaPadrao ? 1 : 0;
          return isTopB - isTopA;
        });
      }

      // Formato para o componente de forma de pagamento (com objeto completo)
      this.contasFormatadas = response.content
        .filter((conta: any) => conta.tipoConta === 'BANCO' || conta.tipoConta?.enum === 'BANCO')
        .map((conta: any) => ({
          label: conta.tituloDaConta,
          value: conta,
        }));

      // Contas prontas: sinalizar e tentar disparar carga inicial coordenada.
      // A auto-selecao da conta DINHEIRO acontece dentro de dispararCargaInicialSePronto()
      // ANTES do primeiro loadReceitas, para que o primeiro load ja saia com conta=<id>.
      this._contasReady = true;
      this.dispararCargaInicialSePronto();
    });
  }

  loadReceitas(page: number, size: number) {
    this.loading = true;

    // Se filtros estao ativos, usar endpoint com filtros
    if (this.filtrosAtivos) {
      this.loadReceitasComFiltros(page, size);
      return;
    }

    this.receitaService.get('/movimento/tipoTransacao', {
      tipoTransacao: 'RECEITA',
      page,
      size,
      sort: `${this.lastfield},${this.lastSort}`,
    }).subscribe({
      next: (response: any) => {
        if (response && response.content) {
          // Normalizar tipoReceita: a API retorna objeto { nome, id, ... }
          // mas o template acessa receita.tipoReceita?.nome
          this.receitasOriginal = response.content.map((r: any) => ({
            ...r,
            tipoReceita: r.tipoReceita
              ? (typeof r.tipoReceita === 'object'
                ? { ...r.tipoReceita, icone: r.tipoReceita.icone || this.tipoReceitaMap.get(r.tipoReceita.nome)?.icone || '', cor: r.tipoReceita.cor || this.tipoReceitaMap.get(r.tipoReceita.nome)?.cor || '' }
                : { nome: r.tipoReceita, icone: this.tipoReceitaMap.get(r.tipoReceita)?.icone || '', cor: this.tipoReceitaMap.get(r.tipoReceita)?.cor || '' })
              : undefined,
          }));
          this.receitas = [...this.receitasOriginal];
          this.totalRecords = response.totalElements || response.content.length;
        } else {
          this.receitasOriginal = [];
          this.receitas = [];
          this.totalRecords = 0;
        }

        // Reaplicar filtros locais (busca textual + moeda)
        if ((this.searchTerm && this.searchTerm.trim().length > 0) || this.filtroMoedaSelecionada) {
          this.aplicarFiltrosLocais();
        }

        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  /** Carrega receitas usando endpoint com filtros server-side */
  private loadReceitasComFiltros(page: number, size: number): void {
    const filtros = this.montarFiltrosDTO(page, size);

    this.receitaService.listarComFiltros(filtros).subscribe({
      next: (response) => {
        if (response && response.content) {
          // Mapear ReceitaDashboardDTO para o formato que a tabela usa
          this.receitasOriginal = response.content.map((d: ReceitaDashboardDTO) => ({
            id: d.id,
            observacao: d.observacao || '',
            tipoDeTransacao: d.tipoDeTransacao || 'RECEITA',
            tipoReceita: d.tipoReceita
              ? (typeof (d.tipoReceita as any) === 'object'
                ? { ...(d.tipoReceita as any), icone: (d.tipoReceita as any).icone || this.tipoReceitaMap.get((d.tipoReceita as any).nome)?.icone || '', cor: (d.tipoReceita as any).cor || this.tipoReceitaMap.get((d.tipoReceita as any).nome)?.cor || '' }
                : { nome: d.tipoReceita, icone: this.tipoReceitaMap.get(d.tipoReceita)?.icone || '', cor: this.tipoReceitaMap.get(d.tipoReceita)?.cor || '' })
              : undefined,
            cancelado: false,
            valor: this.resolverValorNaMoedaDaConta(d),
            cotacao_id: 0,
            moedaDeOrigem: this.resolverMoedaParaExibicao(d),
            valorRecebidoNaConta: d.valorRecebidoNaConta || 0,
            valorRecebidoEmGuarani: d.valorRecebidoEmGuarani || 0,
            valorRecebidoEmDolar: d.valorRecebidoEmDolar || 0,
            valorRecebidoEmReal: d.valorRecebidoEmReal || 0,
            valorRecebidoEmPeso: d.valorRecebidoEmPeso || 0,
            emissao: d.emissao ? new Date(d.emissao) : undefined,
            baixas: [],
            pessoa: d.pessoa,
            pessoa_id: d.pessoa?.id || null,
            tipo: d.tipo || 'MOVIMENTO',
          } as any));
          this.receitas = [...this.receitasOriginal];
          this.totalRecords = response.totalElements || response.content.length;
        } else {
          this.receitasOriginal = [];
          this.receitas = [];
          this.totalRecords = 0;
        }

        // Reaplicar filtros locais (busca textual + moeda)
        if ((this.searchTerm && this.searchTerm.trim().length > 0) || this.filtroMoedaSelecionada) {
          this.aplicarFiltrosLocais();
        }

        this.loading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar receitas com filtros:', error);
        this.loading = false;
      }
    });
  }

  /** Monta o DTO de filtros a partir das propriedades do componente */
  private montarFiltrosDTO(page: number, size: number): ReceitaFiltrosDTO {
    const filtros: ReceitaFiltrosDTO = {
      page: page,
      size: size,
      sort: `${this.lastfield},${this.lastSort}`,
    };

    if (this.filtroObservacao && this.filtroObservacao.trim()) {
      filtros.observacao = this.filtroObservacao.trim();
    }
    if (this.filtroPessoaId != null) {
      filtros.pessoaId = this.filtroPessoaId;
    }
    if (this.filtroTipoReceita) {
      filtros.tipoReceita = this.filtroTipoReceita;
    }
    if (this.filtroDataInicio) {
      filtros.dataInicio = this.formatarDataFiltro(this.filtroDataInicio);
    }
    if (this.filtroDataFim) {
      filtros.dataFim = this.formatarDataFiltro(this.filtroDataFim, true);
    }
    if (this.filtroConta != null) {
      filtros.conta = this.filtroConta;
    }

    return filtros;
  }

  /** Formata data para dd/MM/yyyyTHH:mm (formato esperado pelo backend) */
  private formatarDataFiltro(data: Date, fimDoDia: boolean = false): string {
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    const horas = fimDoDia ? '23:59' : '00:00';
    return `${dia}/${mes}/${ano}T${horas}`;
  }

  /** Aplica filtros server-side */
  /** Recebe o periodo selecionado pelo componente periodo-filtro e converte para Date */
  onPeriodoReceitaChanged(periodo: PeriodoFiltro): void {
    this.periodoReceitaTexto = periodo.texto;
    this.filtroDataInicio = this.parsarDataDashboard(periodo.dataInicio);
    this.filtroDataFim = this.parsarDataDashboard(periodo.dataFim);
    this.aplicarFiltros();
  }

  /** Chamado quando o dropdown de conta muda */
  onContaFiltroChange(): void {
    // moedaContaSelecionada já retorna null quando filtroConta é null,
    // e retorna o enum correto tanto para contas DINHEIRO/EFETIVO quanto para contas BANCO.
    this.filtroMoedaSelecionada = this.moedaContaSelecionada;
    this.aplicarFiltros();
  }

  aplicarFiltros(): void {
    this.filtrosAtivos = true;
    this.first = 0;
    this.loadReceitas(0, this.rows);
    this.carregarTotais();
  }

  /** Limpa filtros avançados do sidebar e reseta para período padrão (mês atual).
   *  Nota: filtroConta e filtroMoedaSelecionada pertencem ao header inline,
   *  não ao sidebar de filtros avançados, por isso não são limpos aqui. */
  limparFiltros(): void {
    this.filtroObservacao = '';
    this.filtroPessoaId = null;
    this.filtroPessoaSelecionada = undefined;
    this.filtroTipoReceita = null;
    this.searchTerm = '';
    this.first = 0;

    // Manter periodo padrao (mes atual) como o mobile faz,
    // em vez de remover datas e trocar de endpoint
    const hoje = new Date();
    this.filtroDataInicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1, 0, 0, 0);
    this.filtroDataFim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0, 23, 59, 59);
    this.filtrosAtivos = true;

    this.loadReceitas(0, this.rows);
    this.carregarTotais();
  }

  /** Filtra a tabela pela moeda clicada no card de totais.
   *  Clicar novamente no mesmo card remove o filtro (toggle).
   *  Seleciona automaticamente a conta DINHEIRO da moeda clicada e faz nova busca na API. */
  filtrarPorMoeda(moeda: string): void {
    // Bloquear clique quando conta bancaria esta ativa
    if (this.contaBancariaAtiva) {
      return;
    }

    // Se ja esta selecionada, manter o filtro (sem toggle)
    if (this.filtroMoedaSelecionada === moeda) {
      return;
    }

    // Selecionar a conta DINHEIRO da moeda clicada e fazer nova busca na API
    const contaDinheiroMoeda = this.contasFull.find(c => {
      const tipo = this.asEnumString(c.tipoConta);
      const moedaConta = this.asEnumString(c.moeda);
      return tipo !== 'BANCO' && moedaConta === moeda.toUpperCase();
    });

    if (contaDinheiroMoeda) {
      this.filtroConta = contaDinheiroMoeda.id;
      this.filtroMoedaSelecionada = moeda;
      this.aplicarFiltros();
    } else {
      // Fallback: filtro local se nao encontrar conta DINHEIRO
      this.filtroMoedaSelecionada = moeda;
      this.aplicarFiltrosLocais();
    }
  }

  /** Aplica filtros locais (busca textual + moeda) sobre receitasOriginal */
  private aplicarFiltrosLocais(): void {
    let resultado = [...this.receitasOriginal];

    // Filtro por moeda — somente quando nao ha filtro de conta server-side,
    // pois o backend ja filtra por conta e a moedaDeOrigem pode diferir da conta filtrada
    if (this.filtroMoedaSelecionada && this.filtroConta == null) {
      const moedaFiltro = this.filtroMoedaSelecionada.toUpperCase();
      resultado = resultado.filter(r => {
        const moedaReceita = this.asEnumString(r.moedaDeOrigem).toUpperCase();
        return moedaReceita === moedaFiltro;
      });
    }

    // Filtro por busca textual
    if (this.searchTerm && this.searchTerm.trim().length > 0) {
      const termLower = this.searchTerm.trim().toLowerCase();
      resultado = resultado.filter(receita => {
        if (this.isColumnVisible('id') && receita.id != null) {
          if (String(receita.id).includes(termLower)) return true;
        }
        if (this.isColumnVisible('emissao') && receita.emissao) {
          const dataFormatada = new Date(receita.emissao as any).toLocaleString('pt-BR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
          });
          if (dataFormatada.toLowerCase().includes(termLower)) return true;
        }
        if (this.isColumnVisible('observacao') && receita.observacao) {
          if (receita.observacao.toLowerCase().includes(termLower)) return true;
        }
        if (this.isColumnVisible('tipoReceita') && (receita.tipoReceita as any)) {
          const tipoNome = typeof receita.tipoReceita === 'object' ? (receita.tipoReceita as any)?.nome : String(receita.tipoReceita);
          if (tipoNome && tipoNome.toLowerCase().includes(termLower)) return true;
        }
        if (this.isColumnVisible('valor') && receita.valor != null) {
          const valorStr = String(receita.valor);
          if (valorStr.includes(termLower)) return true;
          const valorFormatado = this.formatarValorMonetario(receita.valor, receita.moedaDeOrigem);
          if (valorFormatado.toLowerCase().includes(termLower)) return true;
        }
        return false;
      });
    }

    this.receitas = resultado;
  }

  /** Carrega totais por moeda */
  carregarTotais(): void {
    const filtros = this.montarFiltrosDTO(0, 0);

    // O endpoint de totais requer dataInicio e dataFim
    // Se nao foram fornecidos, usar data padrao (ultimo ano)
    if (!filtros.dataInicio) {
      const umAnoAtras = new Date();
      umAnoAtras.setFullYear(umAnoAtras.getFullYear() - 1);
      filtros.dataInicio = this.formatarDataFiltro(umAnoAtras);
    }
    if (!filtros.dataFim) {
      filtros.dataFim = this.formatarDataFiltro(new Date(), true);
    }

    this.loadingTotais = true;
    this.receitaService.getTotaisPorMoeda(filtros).subscribe({
      next: (response) => {
        this.totais = response;
        this.loadingTotais = false;
      },
      error: (error) => {
        console.error('Erro ao carregar totais:', error);
        this.loadingTotais = false;
      }
    });
  }

  /** Abre dialogo para selecionar formato de impressao */
  imprimirReceita(id: number, tipo?: string): void {
    this.idParaImprimir = id;
    this.tipoParaImprimir = tipo || 'MOVIMENTO';
    this.mostrarDialogoImpressao = true;
  }

  /** Confirma impressao com o formato selecionado */
  confirmarImpressao(): void {
    if (!this.idParaImprimir) return;
    this.imprimindoId = this.idParaImprimir;

    const request$ = this.tipoParaImprimir === 'NOTA'
      ? this.notaService.gerarPdfNota(`/nota/gerar-pdf-nota/${this.idParaImprimir}/impressao/${this.opcaoImpressao}`)
      : this.receitaService.gerarPdfMovimento(this.idParaImprimir, this.opcaoImpressao);

    request$.subscribe({
      next: (base64: string) => {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        this.imprimindoId = null;
        this.mostrarDialogoImpressao = false;
      },
      error: (error) => {
        console.error('Erro ao gerar PDF:', error);
        this.imprimindoId = null;
      }
    });
  }

  private setupSearchDebounce() {
    this.search$.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      this.first = 0;

      if ((term && term.trim().length > 0) || this.filtroMoedaSelecionada) {
        this.aplicarFiltrosLocais();
      } else {
        // Sem termo de busca e sem filtro de moeda, restaurar lista original
        this.receitas = [...this.receitasOriginal];
        this.totalRecords = this.receitasOriginal.length;
      }
    });
  }

  selecionarData(tipo: string): void {
    this.dataSelecionada = tipo;

    const hoje = new Date();

    switch (tipo) {
      case 'hoje':
        this.form.emissao = new Date();
        this.outrosLabel = this.labels.outros;
        break;
      case 'ontem':
        const ontem = new Date(hoje);
        ontem.setDate(hoje.getDate() - 1);
        this.form.emissao = ontem;
        this.outrosLabel = this.labels.outros;
        break;
      case 'outros':
        if (!this.form.emissao) {
          this.form.emissao = new Date();
        }
        break;
    }

    if (this.form.emissao) {
      this.form.emissao = this.formatarDataParaAPI(this.form.emissao);
    }
  }

  abrirCalendario(): void {
    this.dataSelecionada = 'outros';
    setTimeout(() => {
      if (this.calendario) {
        const inputEl = this.calendario.inputfieldViewChild?.nativeElement;
        if (inputEl) {
          // Temporariamente habilitar o input para receber foco
          inputEl.removeAttribute('tabindex');
          inputEl.style.pointerEvents = 'auto';
          inputEl.focus();
          inputEl.click();
          // Voltar a desabilitar apos abrir
          setTimeout(() => {
            inputEl.setAttribute('tabindex', '-1');
            inputEl.style.pointerEvents = 'none';
          }, 100);
        }
      }
    }, 0);
  }

  onDataSelecionada(): void {
    if (this.form.emissao) {
      this.form.emissao = this.formatarDataParaAPI(this.form.emissao);
      // Atualizar label do botao "Outros" com a data selecionada
      this.outrosLabel = this.formatarDataParaExibicao(this.form.emissao);
    }
  }

  private definirDataHoje(): void {
    this.form.emissao = new Date();
    this.form.emissao = this.formatarDataParaAPI(this.form.emissao);
  }

  onSearchChange(value: string) {
    this.searchTerm = value || '';
    this.search$.next(this.searchTerm);
  }

  limparFormulario() {
    this.form = this.createEmptyForm();
    this.montanteStr = '';
    this.dataSelecionada = 'hoje';
    this.outrosLabel = this.labels.outros;
    this.definirDataHoje();
    this.isFormSubmitted = false;
    this.pessoaSelecionada = undefined;
    // Voltar titulo para modo criacao
    this.texts.titulo = this.translate.instant('nova-receita.texts.titulo_nova');
    this.texts.subtitulo = this.translate.instant('nova-receita.texts.subtitulo_nova');
    // Voltar para aba de lista
    this.activeTabIndex = 1;
    this.cdr.detectChanges();
  }

  onTabChange(event: { index: number }): void {
    // index 0 = Cadastro, index 1 = Lista
    if (event.index === 1) {
      this.texts.titulo = this.translate.instant('nova-receita.texts.titulo_nova');
      this.texts.subtitulo = this.translate.instant('nova-receita.texts.subtitulo_lista');
    } else {
      const isEdicao = !!this.form.id;
      this.texts.titulo = this.translate.instant(
        isEdicao ? 'nova-receita.texts.titulo_editar' : 'nova-receita.texts.titulo_nova'
      );
      this.texts.subtitulo = this.translate.instant(
        isEdicao ? 'nova-receita.texts.subtitulo_editar' : 'nova-receita.texts.subtitulo_nova'
      );
    }
  }

  novaReceita(): void {
    this.form = this.createEmptyForm();
    this.montanteStr = '';
    this.dataSelecionada = 'hoje';
    this.outrosLabel = this.labels.outros;
    this.definirDataHoje();
    this.isFormSubmitted = false;
    this.pessoaSelecionada = undefined;
    this.texts.titulo = this.translate.instant('nova-receita.texts.titulo_nova');
    this.texts.subtitulo = this.translate.instant('nova-receita.texts.subtitulo_nova');
    this.activeTabIndex = 0;
    this.cdr.detectChanges();
  }

  onDataChange() {
    if (this.dataSelecionada === 'hoje') {
      this.form.emissao = new Date();
    } else if (this.dataSelecionada === 'ontem') {
      const ontem = new Date();
      ontem.setDate(ontem.getDate() - 1);
      this.form.emissao = ontem;
    } else {
      this.form.emissao = undefined;
    }
  }

  private formatarDataParaAPI(data: Date): Date {
    const d = data instanceof Date ? data : new Date(data);
    const agora = new Date();
    return new Date(
      d.getFullYear(), d.getMonth(), d.getDate(),
      agora.getHours(), agora.getMinutes(), agora.getSeconds()
    );
  }

  private formatarDataParaExibicao(data: Date): string {
    const d = new Date(data);
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  async submit() {
    if (this.submitting) return;
    this.isFormSubmitted = true;

    // Validar campos obrigatorios antes de abrir dialogo de pagamento
    if (!this.form.moeda) {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-receita.messages.moeda_obrigatoria') });
      return;
    }
    if (!this.form.valor || this.form.valor <= 0) {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-receita.messages.valor_obrigatorio') });
      return;
    }
    if (!this.form.tipoReceita) {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-receita.messages.tipo_obrigatorio') });
      return;
    }

    // Validar descricao obrigatoria quando tipo OUTROS
    if (this.asEnumString(this.form.tipoReceita) === 'OUTROS') {
      const descricao = (this.form.descricao || '').trim();
      if (!descricao) {
        this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-receita.messages.descricao_obrigatoria_outros') });
        return;
      }
      if (descricao.length < 10) {
        this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-receita.messages.descricao_minimo_caracteres') });
        return;
      }
    }

    // Sincronizar moeda do dialog com a MOEDA DO REGISTRO (form.moeda).
    // Justificativa: o usuario escolheu a moeda da receita no formulario e
    // a matriz canonica MOEDAS_COMPATIVEIS deve ser aplicada sobre essa
    // moeda — espelha o backend (MoedaPareamentoValidator).
    //
    // Comportamento resultante por moeda do registro:
    //   - GUARANI -> cards PYG, BRL, USD, ARS (universal)
    //   - REAL    -> cards PYG, BRL, USD
    //   - DOLAR   -> cards PYG, BRL, USD
    //   - PESO    -> cards PYG, ARS
    //
    // Fallback: usa empresa.moeda caso form.moeda esteja indefinida (a
    // validacao acima impede esse cenario no fluxo normal).
    const moedaMap: Record<string, 'BRL' | 'PYG' | 'USD' | 'ARS'> = {
      'REAL': 'BRL',
      'GUARANI': 'PYG',
      'DOLAR': 'USD',
      'PESO': 'ARS',
    };
    const moedaBaseRaw = this.form.moeda ?? this.empresa?.moeda;
    const moedaBaseEnum = this.asEnumString(moedaBaseRaw);
    this.moedaPadraoISO = moedaMap[moedaBaseEnum] ?? 'BRL';

    // Sincronizar tambem a moeda da empresa (segundo filtro). O dialog
    // aplica a intersecao das duas matrizes ao decidir quais cards renderizar.
    // Ex.: registro em GUARANI + empresa em REAL -> oculta PESO.
    const moedaEmpresaEnum = this.asEnumString(this.empresa?.moeda);
    this.moedaEmpresaISO = moedaMap[moedaEmpresaEnum];

    // Garante a cotacao do dia ANTES do pagamento (solicita ao usuario se nao houver).
    const cotacao = await this.cotacaoGuard.garantirCotacao({ moeda: this.getEmpresaMoedaPadrao() });
    if (!cotacao) {
      return;
    }
    this.carregarCotacoes();

    // Abrir dialogo de forma de pagamento
    this.mostrarDialogPagamento = true;
  }

  async onPagamentoConfirmado(result: FormaPagamentoResult): Promise<void> {
    if (this.processandoReceita) return;
    this.processandoReceita = true;

    try {
      await this.montaMovimento();

      // Preencher dados de pagamento conforme forma selecionada
      if (result.forma === 'dinheiro') {
        const dados = result.dados as DadosPagamentoDinheiro;
        this.movimento.valorRecebidoEmGuarani = dados.valorRecebidoEmGuarani || 0;
        this.movimento.valorRecebidoEmDolar = dados.valorRecebidoEmDolar || 0;
        this.movimento.valorRecebidoEmReal = dados.valorRecebidoEmReal || 0;
        this.movimento.valorRecebidoEmPeso = dados.valorRecebidoEmPeso || 0;
        this.movimento.valorRecebidoNaConta = 0;
      }

      if (result.forma === 'conta') {
        const dados = result.dados as DadosPagamentoConta;
        this.movimento.valorRecebidoNaConta = this.form.valor!;
        this.movimento.contaId = dados.conta_id;
        this.movimento.moedaDaConta = dados.moedaDaConta;
        this.movimento.informacaoDaTransacao = dados.informacaoDaTransacao;
        this.movimento.valorRecebidoEmGuarani = 0;
        this.movimento.valorRecebidoEmDolar = 0;
        this.movimento.valorRecebidoEmReal = 0;
        this.movimento.valorRecebidoEmPeso = 0;
      }

      const isUpdate = !!this.form.id;
      const request$ = isUpdate
        ? this.receitaService.put(`/movimento/${this.form.id}`, this.movimento)
        : this.receitaService.post('/movimento', this.movimento);

      request$.subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant('common.sucesso'),
            detail: this.translate.instant(isUpdate ? 'Receita_Atualizada_com_sucesso' : 'Receita_Adicionada_com_sucesso')
          });
          this.mostrarDialogPagamento = false;
          this.isFormSubmitted = false;
          this.form = this.createEmptyForm();
          this.montanteStr = '';
          this.dataSelecionada = 'hoje';
          this.definirDataHoje();
          this.buildMoedaOptions();
          // Usar moeda padrao da empresa como fallback (nao hardcodar GUARANI)
          const moedaEmpresaReset = this.empresa?.moeda
            ? this.moeda.find(m => this.asEnumString(m.value) === this.asEnumString(this.empresa!.moeda)) ?? this.moeda[0]
            : this.moeda[0];
          this.form.moeda = moedaEmpresaReset;
          this.loadReceitas(0, this.rows);
          if (this.filtrosAtivos) {
            this.carregarTotais();
          }
          this.loadTranslations();
          this.activeTabIndex = 1; // Trocar para aba de lista
        },
      });
    } catch (error) {
      console.error('Erro ao criar receita:', error);
    } finally {
      this.processandoReceita = false;
    }
  }

  async montaMovimento() {

    const cotacao = await this.buscarUltimaCotacaoPorMoeda(this.getEmpresaMoedaPadrao());

    this.movimento = {
      id: this.form.id || undefined,
      codigoMovimento: null,
      observacao: this.form.descricao?.trim() || null,
      tipoDeTransacao: 'RECEITA',
      tipoReceita: this.asEnumString(this.form.tipoReceita),
      tipoMovimento: 'ENTRADA',
      //contaId: 0,
      pessoaId: this.form.pessoa_id ?? null,
      valor: this.form.valor!,
      cotacaoId: cotacao.id,
      valorRecebidoNaConta: 0,
      valorRecebidoEmGuarani: this.form.valor!,
      valorRecebidoEmDolar: 0,
      valorRecebidoEmReal: 0,
      valorRecebidoEmPeso: 0,
      valorTotalMoedaPadrao: this.form.valor!,
      moedaDeOrigem: this.asEnumString(this.form.moeda),
      moedaDeDestino: this.asEnumString(this.form.moeda),
      cancelado: false,
      emissao: toLocalISOString(this.form.emissao instanceof Date ? this.form.emissao : new Date()),
      baixas: [],
    };
  }

  /** Retorna o tipo de transacao normalizado (VENDA, TRANSFERENCIA, RECEITA, etc.) */
  private getTipoTransacao(receita: any): string {
    return this.asEnumString(receita.tipoDeTransacao).toUpperCase();
  }

  /** Verifica se o ingresso eh uma venda ou devolucao (tem fatura associada) */
  isNotaReceita(receita: any): boolean {
    const tipo = this.getTipoTransacao(receita);
    return tipo === 'VENDA' || tipo === 'DEVOLUCAO_DE_COMPRA';
  }

  /** Verifica se o ingresso eh uma transferencia */
  isTransferenciaReceita(receita: any): boolean {
    return this.getTipoTransacao(receita) === 'TRANSFERENCIA';
  }

  /** Retorna o icone adequado para o botao de acao */
  getIconeAcao(receita: any): string {
    if (this.isNotaReceita(receita)) return 'pi pi-file';
    return 'pi pi-pencil';
  }

  /** Retorna o tooltip adequado para o botao de acao */
  getTooltipAcao(receita: any): string {
    if (this.isNotaReceita(receita)) return this.tooltips.ver_fatura;
    if (this.isTransferenciaReceita(receita)) return this.tooltips.ver_transferencia;
    return this.tooltips.editar;
  }

  /**
   * Handler do botao de acao da tabela de receitas.
   * - Tipos internos (fluxo nova-receita): edita inline via editarReceita().
   * - Tipos externos (fatura / transferencia): abre em nova aba.
   */
  abrirReceitaNovaAba(receita: ReceitaDTO) {
    const tipo = this.getTipoTransacao(receita);

    // Tipos do fluxo da propria pagina nova-receita: editar inline
    const tiposInline: readonly string[] = [
      'RECEITA',
      'JUROS_RECEBIDOS',
      'DESCONTOS_RECEBIDOS',
      'OUTROS',
    ];
    if (tiposInline.includes(tipo)) {
      // Buscar dados completos do backend antes de editar inline, pois o objeto
      // da listagem tem tipoReceita como { nome, icone, cor } e nao como string
      // enum — o que impede o find() em editarReceita de localizar o tipo no
      // dropdown. carregarReceitaParaEdicao faz o fetch e chama editarReceita
      // com o payload completo do endpoint /movimento/{id}.
      if (receita.id) {
        this.carregarReceitaParaEdicao(receita.id);
      } else {
        this.editarReceita(receita);
      }
      return;
    }

    // Tipos externos: mantem comportamento de nova aba
    let url: string;
    if (tipo === 'VENDA' || tipo === 'DEVOLUCAO_DE_COMPRA') {
      url = this.router.serializeUrl(
        this.router.createUrlTree(['/notas-list/fatura', receita.id])
      );
    } else if (tipo === 'TRANSFERENCIA') {
      url = this.router.serializeUrl(
        this.router.createUrlTree(['/nova-transferencia'], { queryParams: { editId: receita.id } })
      );
    } else {
      // Fallback defensivo para tipo desconhecido: edita inline
      this.editarReceita(receita);
      return;
    }
    window.open(url, '_blank');
  }

  editarReceita(receita: ReceitaDTO) {
    const dataEmissao =
      receita.emissao ? new Date(receita.emissao as any) : undefined;

    this.dataSelecionada = 'outros';
    this.form.emissao = dataEmissao;

    // BUG FIX: atualizar label do botao "Otros" com a data real do registro
    if (dataEmissao) {
      this.outrosLabel = this.formatarDataParaExibicao(dataEmissao);
    } else {
      this.outrosLabel = this.labels.outros;
    }

    const tipoReceitaValue =
      receita.tipoReceita ??
      null;

    const tipoReceitaCorrespondente =
      this.tiposReceita.find(
        t => this.asEnumString(t.value) === this.asEnumString(tipoReceitaValue)
      )?.value ?? null;

    // BUG FIX: comparar ids como numero para evitar falha por diferenca de tipo
    const pessoaId = receita.pessoa?.id ?? receita.pessoa_id ?? null;
    const clienteCorrespondente = pessoaId != null
      ? this.clientes.find(c => Number(c.id) === Number(pessoaId))
      : undefined;

    const moedaCorrespondente =
      this.moeda.find(
        m =>
          this.asEnumString(m.value) ===
          this.asEnumString(receita.moedaDeOrigem ?? receita.moeda)
      ) || undefined;

    this.form = {
      id: receita.id,
      observacao: receita.observacao,
      tipoDeTransacao: receita.tipoDeTransacao,
      tipoReceita: tipoReceitaCorrespondente as TipoDeReceita | undefined,
      cancelado: receita.cancelado,
      valor: receita.valor,
      cotacao_id: receita.cotacao_id,
      conta_id: receita.conta_id,
      pessoa_id:
        clienteCorrespondente?.id ??
        receita.pessoa?.id ??
        receita.pessoa_id ??
        null,
      moedaDeOrigem: receita.moedaDeOrigem,
      moeda: moedaCorrespondente,
      contaDestino_id: receita.contaDestino_id,
      valorRecebidoNaConta: receita.valorRecebidoNaConta,
      valorRecebidoEmGuarani: receita.valorRecebidoEmGuarani,
      valorRecebidoEmDolar: receita.valorRecebidoEmDolar,
      valorRecebidoEmReal: receita.valorRecebidoEmReal,
      emissao: dataEmissao,
      baixas: receita.baixas,
      descricao: receita.observacao
    };

    // Popular string formatada do campo de valor para exibicao correta no input
    this.montanteStr = this.formatarMontanteParaExibicao(
      receita.valor ?? 0,
      moedaCorrespondente?.value
    );

    // Atualizar titulo/subtitulo para modo edicao
    this.texts.titulo = this.translate.instant('nova-receita.texts.titulo_editar');
    this.texts.subtitulo = this.translate.instant('nova-receita.texts.subtitulo_editar');

    // Atualizar pessoaSelecionada para entity-selector
    if (receita.pessoa) {
      this.pessoaSelecionada = receita.pessoa as PessoaDTO;
    } else if (pessoaId) {
      this.pessoaService.getById('/pessoas', String(pessoaId)).subscribe(
        (pessoa: PessoaDTO) => { this.pessoaSelecionada = pessoa; },
        () => { /* ignora erro - campo pessoa fica vazio */ }
      );
    } else {
      this.pessoaSelecionada = undefined;
    }

    // Trocar para aba de cadastro com os dados preenchidos
    this.activeTabIndex = 0;
  }

  /** Converte um valor numerico para a string formatada exibida no campo de valor */
  private formatarMontanteParaExibicao(valor: number, moeda: Moeda | undefined): string {
    if (valor == null || isNaN(valor) || valor <= 0) return '';

    if (moeda === Moeda.GUARANI) {
      const intVal = Math.round(valor);
      return intVal
        ? intVal.toLocaleString('es-PY', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        : '';
    } else if (moeda === Moeda.DOLAR) {
      return valor
        ? valor.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
    } else {
      return valor
        ? valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
    }
  }

  private createEmptyForm(): ReceitaDTO {
    return {
      observacao: '',
      tipoDeTransacao: TipoTransacao.RECEITA,
      tipoReceita: '',
      cancelado: false,
      valor: null,
      cotacao_id: 0,
      conta_id: null,
      pessoa_id: null,
      moedaDeOrigem: '',
      moeda: undefined,
      contaDestino_id: null,
      valorRecebidoNaConta: 0,
      valorRecebidoEmGuarani: 0,
      valorRecebidoEmDolar: 0,
      valorRecebidoEmReal: 0,
      emissao: undefined,
      baixas: [],
    };
  }

  private getEnumOptions(enumType: any): { label: string; value: string }[] {
    return Object.values(enumType).map((value) => ({ label: value as string, value: value as string }));
  }

  /**
   * Cotacao de hoje da moeda padrao (solicitada ao usuario quando nao cadastrada).
   * Sem cotacao a operacao e abortada: nunca usa id generico.
   */
  async buscarUltimaCotacaoPorMoeda(moeda: Moeda): Promise<any> {
    const cotacao = await this.cotacaoGuard.garantirCotacao({ moeda });
    if (!cotacao) {
      throw new Error('cotacao_cancelada');
    }
    return cotacao;
  }

  private getEmpresaMoedaPadrao(): Moeda {
    const moeda = this.empresa?.moeda as MoedaDTO | undefined;
    if (moeda) {
      return this.asMoedaEnum(moeda);
    }
    return this.asMoedaEnum(this.form.moeda?.value);
  }

  private asMoedaEnum(value: any): Moeda {
    if (!value) return Moeda.REAL;

    const stringValue = this.asEnumString(value).toUpperCase();

    switch (stringValue) {
      case 'GUARANI':
        return Moeda.GUARANI;
      case 'REAL':
        return Moeda.REAL;
      case 'DOLAR':
        return Moeda.DOLAR;
      case 'PESO':
        return Moeda.PESO;
      default:
        return Moeda.REAL;
    }
  }

  validaMoedaValor(moeda: Moeda): number {
    const valor = this.form.valor || 0;
    valor > 0 ? valor : valor * -1;

    if (moeda == Moeda.DOLAR) {
      return valor;
    } else if (moeda == Moeda.GUARANI) {
      return valor;
    }
    return valor;
  }

  onMoedaChange(newMoeda: any): void {
    setTimeout(() => {
      this.processCurrencyChange(newMoeda);
    }, 0);
  }

  private processCurrencyChange(newMoeda: any): void {
    if (this.form.valor === null || this.form.valor === undefined || this.form.valor === 0) {
      return;
    }

    const currentValue = this.form.valor.toString();

    if (newMoeda?.value === Moeda.GUARANI) {
      this.formatValueForGuarani(currentValue);
    }
  }


  private formatValueForGuarani(value: string): void {
    let cleanValue: string = value;

    if (cleanValue.includes('.')) {
      cleanValue = cleanValue.split('.')[0];
    }

    cleanValue = cleanValue.replace(/[^\d-]/g, '');

    if (cleanValue.includes('-')) {
      cleanValue = '-' + cleanValue.replace(/-/g, '');
    }

    let numericValue: number | null;
    if (cleanValue === '' || cleanValue === '-') {
      numericValue = null;
    } else {
      numericValue = parseInt(cleanValue, 10);
    }

    this.form.valor = numericValue;
  }

  getSelectedCurrencySymbol(): string {
    if (!this.form.moeda) {
      return '';
    }

    return this.getCurrencySymbol(this.form.moeda.value);
  }

  private getCurrencySymbol(moeda: Moeda): string {
    switch (moeda) {
      case Moeda.REAL:
        return 'R$';
      case Moeda.DOLAR:
        return '$';
      case Moeda.GUARANI:
        return 'Gs';
      case Moeda.PESO:
        return '$';
      default:
        return '';
    }
  }

  formatarValorMonetario(valor: number, moedaDeOrigem: any): string {
    if (valor == null || isNaN(valor)) return '-';

    const moedaStr = this.asEnumString(moedaDeOrigem).toUpperCase();

    const configuracoes: Record<string, { locale: string; simbolo: string; decimais: boolean }> = {
      'GUARANI': { locale: 'es-PY', simbolo: 'Gs', decimais: false },
      'REAL': { locale: 'pt-BR', simbolo: 'R$', decimais: true },
      'DOLAR': { locale: 'en-US', simbolo: '$', decimais: true },
      'PESO': { locale: 'es-AR', simbolo: '$', decimais: true },
    };

    const config = configuracoes[moedaStr] ?? configuracoes['GUARANI'];
    const options: Intl.NumberFormatOptions = config.decimais
      ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      : { minimumFractionDigits: 0, maximumFractionDigits: 0 };

    const valorFormatado = new Intl.NumberFormat(config.locale, options).format(valor);
    return `${config.simbolo} ${valorFormatado}`;
  }

  /**
   * Para transferencias entre moedas, o campo 'valor' vem na moeda de origem (ex: USD 50),
   * mas a lista exibe na moeda da conta selecionada. Retorna o valorRecebidoEm{Moeda} correto.
   */
  private resolverValorNaMoedaDaConta(d: any): number {
    const moedaConta = this.moedaContaSelecionada?.toUpperCase();
    if (!moedaConta) return d.valor || 0;
    if (moedaConta === 'GUARANI' && d.valorRecebidoEmGuarani) return d.valorRecebidoEmGuarani;
    if (moedaConta === 'DOLAR' && d.valorRecebidoEmDolar) return d.valorRecebidoEmDolar;
    if (moedaConta === 'REAL' && d.valorRecebidoEmReal) return d.valorRecebidoEmReal;
    if (moedaConta === 'PESO' && d.valorRecebidoEmPeso) return d.valorRecebidoEmPeso;
    return d.valor || 0;
  }

  /**
   * Quando ha conta selecionada, a moeda exibida deve ser a da conta,
   * nao a moedaDeOrigem do movimento (que pode ser outra em vendas multi-moeda).
   */
  private resolverMoedaParaExibicao(d: any): any {
    const moedaConta = this.moedaContaSelecionada?.toUpperCase();
    if (!moedaConta) return d.moedaDeOrigem;
    const moedaOrigem = this.asEnumString(d.moedaDeOrigem).toUpperCase();
    if (moedaOrigem === moedaConta) return d.moedaDeOrigem;
    // A moeda de origem difere da conta — retornar enum da moeda da conta
    return moedaConta;
  }

  private asEnumString(v: any): string {
    if (!v) return '';

    if (typeof v === 'object' && 'enum' in v) {
      return String(v.enum).toUpperCase();
    }

    if (typeof v === 'string') {
      return v.toUpperCase();
    }

    if (typeof v === 'object' && 'value' in v) {
      return String(v.value).toUpperCase();
    }

    return String(v ?? '').toUpperCase();
  }

  formataCampoValor(event?: any): void {
    const input = event.target as HTMLInputElement;
    const raw = input.value || '';
    // Remove tudo que nao e digito
    const onlyDigits = raw.replace(/\D+/g, '');
    const moeda = this.form.moeda?.value;

    if (!onlyDigits) {
      this.form.valor = null;
      this.montanteStr = '';
      input.value = '';
      return;
    }

    if (moeda === Moeda.GUARANI) {
      // Guarani: sem centavos, apenas separador de milhar
      const intVal = parseInt(onlyDigits, 10);
      this.form.valor = intVal || null;
      const formatted = intVal
        ? intVal.toLocaleString('es-PY', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        : '';
      this.montanteStr = formatted;
      input.value = formatted;
    } else if (moeda === Moeda.DOLAR) {
      // Dolar: 2 casas decimais, formato 1,234.56
      const cents = parseInt(onlyDigits, 10);
      const val = cents / 100;
      this.form.valor = cents ? val : null;
      const formatted = cents
        ? val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
      this.montanteStr = formatted;
      input.value = formatted;
    } else {
      // Real: 2 casas decimais, formato 1.234,56
      const cents = parseInt(onlyDigits, 10);
      const val = cents / 100;
      this.form.valor = cents ? val : null;
      const formatted = cents
        ? val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
      this.montanteStr = formatted;
      input.value = formatted;
    }
  }

  onClienteChange(event: any): void {
    if (event.value === -1) {
      this.abrirDialogoCliente();
      this.form.pessoa_id = null;
      this.clienteSelecionado = null;
    }
  }

  onPessoaSelecionada(pessoa: PessoaDTO): void {
    this.pessoaSelecionada = pessoa;
    this.form.pessoa_id = pessoa?.id ?? null;
  }

  onFiltroPessoaFiltroSelecionada(pessoa: PessoaDTO): void {
    this.filtroPessoaSelecionada = pessoa;
    this.filtroPessoaId = pessoa?.id ?? null;
  }

  onFiltroPessoaFiltroLimpa(): void {
    this.filtroPessoaSelecionada = undefined;
    this.filtroPessoaId = null;
  }

  abrirDialogoCliente(): void {
    this.visibleDialogCliente = true;
    this.cdr.detectChanges();
  }

  /** Handler: cliente novo cadastrado via PessoaAdicionarDialogComponent */
  onClienteCriado(pessoa: PessoaDTO): void {
    this.clientes.push({
      id: pessoa.id,
      nome: pessoa.nome,
      fantasia: (pessoa as any).fantasia,
      email: (pessoa as any).email,
      ruc: (pessoa as any).ruc
    });
    this.pessoaSelecionada = pessoa;
    this.form.pessoa_id = pessoa.id;
    this.cdr.detectChanges();
  }

  /** Handler: cliente ja existente encontrado via RUC no PessoaAdicionarDialogComponent */
  onClienteVinculado(pessoa: PessoaDTO): void {
    this.pessoaSelecionada = pessoa;
    this.form.pessoa_id = pessoa.id;
    this.cdr.detectChanges();
  }

  customSort(event: SortEvent): void {
    if (!event.field) return;
    let field = event.field;

    // Traduz o campo 'valor' para o campo convertido conforme a moeda da conta filtrada
    if (field === 'valor') {
      const moeda = this.moedaContaSelecionada;
      if (moeda === 'GUARANI') field = 'valorRecebidoEmGuarani';
      else if (moeda === 'REAL') field = 'valorRecebidoEmReal';
      else if (moeda === 'DOLAR') field = 'valorRecebidoEmDolar';
      else if (moeda === 'PESO') field = 'valorRecebidoEmPeso';
      // sem moeda selecionada mantém 'valor' como fallback
    }

    const novoSort = (event.order ?? 1) === 1 ? 'asc' : 'desc';

    // Guarda contra re-emissao: ignora se campo e direcao nao mudaram
    if (field === this.lastfield && novoSort === this.lastSort) {
      return;
    }

    // Atualiza os parametros de ordenacao e dispara nova chamada a API
    // para que o sort seja aplicado sobre todos os registros, nao apenas a pagina corrente
    this.lastfield = field;
    this.lastSort = novoSort;
    this.first = 0; // volta para a primeira pagina ao reordenar
    this.loadReceitas(0, this.rows);
  }

  deletarReceita(id: number) {
    this.deleteItemId = id;
    this.deleteDialogVisible = true;
  }

  confirmarExclusao(): void {
    if (!this.deleteItemId) return;

    this.contaService.delete(`/movimento/${this.deleteItemId}`).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('common.sucesso'),
          detail: this.translate.instant('Receita_Excluida_com_sucesso'),
        });
        this.deleteDialogVisible = false;
        this.deleteItemId = null;
        this.loadReceitas(0, this.rows);
      },
      error: () => {
        this.deleteDialogVisible = false;
        this.deleteItemId = null;
      },
    });
  }

  onRowsPerPageChange() {
    // Ignorar disparo espurio do ngModelChange do p-dropdown na inicializacao
    // (antes do primeiro load coordenado em dispararCargaInicialSePronto).
    // Sem esta guarda, o dropdown de "itens por pagina" dispara um
    // loadReceitas SEM filtros aplicados, gerando chamada duplicada.
    if (!this._initialLoadDone) return;
    this.first = 0;
    this.loadReceitas(0, this.rows);
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    const page = event.page;
    const size = event.rows;
    this.loadReceitas(page, size);
  }

  /**
   * Carrega uma receita pelo ID do movimento para edicao.
   * Chamado quando a tela recebe queryParam editId (navegacao da lista de movimentos).
   */
  private carregarReceitaParaEdicao(movimentoId: number): void {
    this.receitaService.getById(`/movimento/${movimentoId}`).subscribe({
      next: (receita: ReceitaDTO) => {
        this.editarReceita(receita);
      },
      error: (err) => {
        console.error('Erro ao carregar receita para edicao:', err);
      },
    });
  }

}
